import { modalsMap } from '../config/modalsMap.ts'
import { wwtModalManagerLog } from '../logger/wwtModalManagerLog.ts'
import type { ModalManagerActions } from '../model/useModalManager.ts'
import { ModalInfo, ModalTypes } from '../types/modalTypes.ts'

interface RenderModalProps {
	modal: ModalInfo<ModalTypes>
	closeModal: ModalManagerActions['closeModal']
}

/**
 * TODO
 *
 * @author Ivan Shchedrovskyi
 */
export const RenderModal = ({ modal, closeModal }: RenderModalProps) => {
	const modalInfo = modalsMap[modal.type]

	if ('dialog' in modalInfo) {
		const ModalForRender = modalInfo.dialog

		return (
			<ModalForRender
				{...modal.modalProps}
				open={true}
				onOpenChange={(open: boolean) => {
					if (!open) {
						wwtModalManagerLog('Close modal with wrapper', modal.props)
						modal.modalProps?.onClose?.()
						closeModal(modal.id)
					}
				}}
				/*  eslint-disable-next-line @typescript-eslint/no-explicit-any */
				{...(modal.props as any)}
			>
				{modal.childModals.length > 0 && (
					<RenderModal
						modal={modal.childModals[0]}
						closeModal={closeModal}
					/>
				)}
			</ModalForRender>
		)
	}

	const ModalForRender = modalInfo.component

	return (
		<ModalForRender
			isOpen={true}
			onClose={() => {
				wwtModalManagerLog('Close modal with wrapper', modal.props)
				modal.modalProps?.onClose?.()
				closeModal(modal.id)
			}}
			modalProps={modal.modalProps}
			/*  eslint-disable-next-line @typescript-eslint/no-explicit-any */
			{...(modal.props as any)}
		>
			{modal.childModals.length > 0 && (
				<RenderModal
					modal={modal.childModals[0]}
					closeModal={closeModal}
				/>
			)}
		</ModalForRender>
	)
}
